<mat-card>
  <mat-card-header class="between">
    <mat-card-title>
      Tow Log{{ !hasPermission || cutsGenerated() ? ' (read only)' : '' }}
    </mat-card-title>
    @if (hasPermission && !cutsGenerated()) {
      @if (edit) {
        <div style="display: flex; gap: 12px">
          <button mat-stroked-button (click)="cancelEdit()">Cancel</button>
          <button mat-flat-button (click)="save()" [disabled]="!changesMade">Save</button>
        </div>
      } @else {
        <button mat-flat-button (click)="startEdit()">Edit</button>
      }
    }
  </mat-card-header>

  <mat-card-content>
    <ag-grid-angular
      class="ag-theme-material"
      [class.editable]="edit"
      [class.readonly]="!edit"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [autoSizeStrategy]="autoSizeStrategy"
      [gridOptions]="gridOptions"
      domLayout="autoHeight"
      (cellDoubleClicked)="onDoubleClick($event)"
      (cellEditingStarted)="checkChangesMade()"
      (cellEditingStopped)="checkChangesMade()"
      (cellKeyDown)="onKeyDown($event)"
      (gridReady)="onGridReady($event)"
    />

    @if (edit) {
      <button mat-button style="width: 100%" (click)="insertRow()">
        <mat-icon>add</mat-icon>
        <span>Add an event (Shift + Enter)</span>
      </button>
    }
  </mat-card-content>
</mat-card>
